import React, { useState, useEffect } from 'react';
import './changepass.css';
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useLocation, useNavigate } from 'react-router-dom';
import { putwithoutAPI } from '../../util/Api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';

const ChangePassword = () => {
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const phone_number = location.state?.phone_number;
  const login = useSelector((state) => state.auth?.auth?.access_token);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [passwordErrors, setPasswordErrors] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false
  });

  // useEffect(() => {
  //   if (!phone_number) {
  //     toast.error("Please verify your phone number first", {
  //       onClose: () => navigate("/creates")
  //     });
  //   }
  // }, [phone_number, navigate]);
  useEffect(() => {
    if (!phone_number) {
      toast.error("Please verify your phone number first");

      // Delay navigation
      setTimeout(() => {
        navigate("/creates");
      }, 3000);
    }
  }, [phone_number, navigate]);

  useEffect(() => {
    if (login) {
      navigate('/user'); // or any page you want
    }
  }, [login, navigate]);

  const validatePassword = (password) => {
    const errors = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      specialChar: /[!@#$%^&*]/.test(password)
    };
    setPasswordErrors(errors);
    return Object.values(errors).every(Boolean);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!newPassword || !confirmPassword) {
      setError("Please fill in all fields");
      return;
    }

    if (!validatePassword(newPassword)) {
      setError("Password doesn't meet requirements");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const response = await putwithoutAPI("/user/update", {
        phone_number,
        password: newPassword,
      });

      if (response.statusCode === 200) {
        toast.success("Password changed successfully!", {
          autoClose: 2000,
          onClose: () => navigate("/login")
        });
      } else {
        setError(response.message || "Password change failed");
      }
    } catch (err) {
      setError("An error occurred. Please try again");
      console.error(err);
    }
  };

  return (
    <>      
    <ToastContainer />

      <div className="change-password-container-forgot">
        <div className="change-password-heading">Change Password</div>

        <form className="change-password-form" onSubmit={handleSubmit}>
          <div className="form-group-change half-width-forgot">
            <label className="form-label">New Password</label>
            <div className="input-wrapper">
              <input
                type={showNew ? 'text' : 'password'}
                placeholder="Password"
                className="input-field-change"
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  validatePassword(e.target.value);
                }}
              />
              <span className="eye-icon-change" onClick={() => setShowNew(!showNew)}>
                {showNew ? <FiEye /> : <FiEyeOff />}
              </span>
            </div>

            {newPassword && (
              <div className="password-requirements">
                <p>Password must contain:</p>
                <ul>
                  <li className={passwordErrors.length ? "valid" : "invalid"}>
                    At least 8 characters
                  </li>
                  <li className={passwordErrors.uppercase ? "valid" : "invalid"}>
                    At least 1 uppercase letter
                  </li>
                  <li className={passwordErrors.lowercase ? "valid" : "invalid"}>
                    At least 1 lowercase letter
                  </li>
                  <li className={passwordErrors.number ? "valid" : "invalid"}>
                    At least 1 number
                  </li>
                  <li className={passwordErrors.specialChar ? "valid" : "invalid"}>
                    At least 1 special character (!@#$%^&*)
                  </li>
                </ul>
              </div>
            )}
          </div>

          <div className="form-group-change half-width-forgot">
            <label className="form-label">Confirm Password</label>
            <div className="input-wrapper">
              <input
                type={showConfirm ? 'text' : 'password'}
                placeholder="Confirm Password"
                className="input-field-change"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <span className="eye-icon-change" onClick={() => setShowConfirm(!showConfirm)}>
                {showConfirm ? <FiEye /> : <FiEyeOff />}
              </span>
            </div>
          </div>

          {error && <div className="otp-error">{error}</div>}

          <div className="save-btn-wrapper">
            <button
              className="save-btn"
              type="submit"
              disabled={!Object.values(passwordErrors).every(Boolean)}
            >
              Change password
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ChangePassword;